import { render, staticRenderFns } from "./ComfyUI.vue?vue&type=template&id=498c30ac&scoped=true"
import script from "./ComfyUI.vue?vue&type=script&lang=js"
export * from "./ComfyUI.vue?vue&type=script&lang=js"
import style0 from "./ComfyUI.vue?vue&type=style&index=0&id=498c30ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498c30ac",
  null
  
)

export default component.exports